export default __webpack_public_path__ + "static/media/pic.406fee68.svg";